var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert border-0",class:_vm.classes,attrs:{"role":"alert"}},[(_vm.icon)?_c('Icon',{staticClass:"me-1",attrs:{"icon":_vm.icon}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }